import {StyleSheet} from 'react-native';

import {pine} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  containerDark: {
    backgroundColor: pine,
    paddingBottom: 32,
    paddingTop: 16,
    width: '100%',
    borderRadius: 20,
  },
  containerLight: {
    borderWidth: 1,
    paddingBottom: 32,
    paddingTop: 16,
    width: '100%',
    borderRadius: 20,
  },
});
